import { type UserEntityPreferredLanguage } from "@/api/__generated__/orval/auth";
import { AVAILABLE_LANGS_SET } from "@/constants/languages.constants";

/**
 * Type guard to check if a value is a supported language
 */
export const isSupportedLang = (
  value: unknown
): value is NonNullable<UserEntityPreferredLanguage> => {
  if (typeof value !== "string") {
    return false;
  }

  return AVAILABLE_LANGS_SET.has(value);
};
